import gpayMicroapp from "./gpayMicroapp";
import { v2PwaBasePath } from '../config/apiEndpoints';
import store from "../store";
import { keyMapsAction, keyMapsMutation } from '../helpers/storeKeys';
import utility from '../helpers/utility';

let gpayPhoneNumber = '';

const getGpayUserIdentityCB = (err , response = {}) => {
    if(err) {
        console.error('ERR: GPAY unable to get user identity', err);
    }
    const result = {}
    result.phoneNumber = gpayPhoneNumber;
    result.identityRes = response || "";
    result.partnerName = utility.getMiniAppStorageVal() || '';
    store.dispatch(keyMapsAction.SIGNIN_MINIAPP, result, {root: true});
}

const getGpayUserPhoneNumber = (location) => {
    gpayMicroapp.getPhoneNumber((err, result) => {
        if(err) {
            console.error('ERR: GPAY unable to get phone number', err);
            localStorage.finalRedirectUrl = location.href;
            window.location.href = v2PwaBasePath + "/login?redirectUrl=" + location.href;
            return;
        }
        gpayPhoneNumber = result || "";
        gpayMicroapp.getIdentity(getGpayUserIdentityCB);
    });
}

export default {getGpayUserPhoneNumber};
